import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

// "G then <key>" style shortcuts, plus single-key helpers.
const STUDENT_MAP = {
  h: "/app/home", j: "/app/journey", q: "/app/quests", r: "/app/replays",
  b: "/app/badges", p: "/app/points", s: "/app/stories", l: "/app/leaderboard",
  f: "/app/performance", u: "/app/profile", n: "/app/notifications",
};
const STAFF_MAP = {
  d: "/staff/dashboard", s: "/staff/students", r: "/staff/reviews",
  c: "/staff/sessions", a: "/staff/attendance", q: "/staff/quests",
};

export default function useKeyboardShortcuts(role) {
  const navigate = useNavigate();
  useEffect(() => {
    if (!role) return;
    let awaitingG = false;
    let timer = null;
    const map = role === "student" ? STUDENT_MAP : STAFF_MAP;

    const isTyping = (el) => el && (["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName) || el.isContentEditable);

    const handler = (e) => {
      if (e.metaKey || e.ctrlKey || e.altKey || isTyping(document.activeElement)) return;
      const key = e.key.toLowerCase();
      if (key === "?") { showHelp(role); return; }
      if (awaitingG) {
        awaitingG = false;
        clearTimeout(timer);
        const dest = map[key];
        if (dest) { e.preventDefault(); navigate(dest); }
        return;
      }
      if (key === "g") {
        awaitingG = true;
        timer = setTimeout(() => { awaitingG = false; }, 1200);
      }
    };
    window.addEventListener("keydown", handler);
    return () => { window.removeEventListener("keydown", handler); clearTimeout(timer); };
  }, [role, navigate]);
}

function showHelp(role) {
  const lines = role === "student"
    ? "G then: H Home · J Journey · Q Quests · R Replays · B Badges · P Points · S Stories · L Leaderboard · F Finale · U Profile"
    : "G then: D Dashboard · S Students · R Reviews · C Sessions · A Attendance · Q Quests";
  toast("⌨️ Keyboard Shortcuts", { description: lines, duration: 6000 });
}
